/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import M_S_FLOOD_NEIGHBOR from "../libre_marker_sini/M_S_FLOOD_NEIGHBOR";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import colors_layer_flood from "../../Data/colors_layer_flood.json";

/*CONST*/

class LAYER_S_FLOOD_NEIGHBOR extends Component {
  componentDidUpdate(prevProps) {
    const state_update_after = this.props.sini.state_update;
    const state_update_before = prevProps.sini.state_update;
    const basemap_used_after = this.props.properties.basemap_used;
    const basemap_used_before = prevProps.properties.basemap_used;

    const map_object_string = this.props.map_object_string || "map_object";
    const map_object = this.props.layer[map_object_string];

    if (
      state_update_after !== state_update_before ||
      basemap_used_after !== basemap_used_before
    ) {
      if (map_object && map_object.isStyleLoaded()) {
        this.on_render_layer();
      } else if (map_object) {
        map_object.once("styledata", this.on_render_layer);
      }
      // this.on_render_layer();
    }
  }

  on_render_layer = () => {
    const {
      sini_v2_list,
      ai_parent_detail_list,
      sini_map_show,
      sini_polygon_fill_opacity,
      sini_polygon_line_width,
      is_sini_visible,
      request_id_active_array,
    } = this.props.sini;
    const map_object_string = this.props.map_object_string || "map_object";
    const map_object = this.props.layer[map_object_string];

    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    if (!!map_object) {
      // Render flood polygons and labels
      merge_array.forEach((item) => {
        const request_id = item?.request_id;
        const visibility =
          sini_map_show.includes("flood_neighbor") &&
          is_sini_visible &&
          request_id_active_array.includes(request_id)
            ? "visible"
            : "none";

        // const flood_neighbor = item?.flood_neighbor || [];
        const flood_intersect_list = item?.flood_intersect_list || [];
        const geojson_flood_neighbor = {
          type: "FeatureCollection",
          features: flood_intersect_list,
        };
        const layer_id_fill = `geojson_flood_neighbor_${request_id}`;
        const layer_id_line = `geojson_flood_neighborline_${request_id}`;
        // Add or update source for flood polygons
        if (!map_object.getSource(layer_id_fill)) {
          map_object.addSource(layer_id_fill, {
            type: "geojson",
            data: geojson_flood_neighbor,
          });
        } else {
          map_object.getSource(layer_id_fill).setData(geojson_flood_neighbor);
        }

        // Add or update fill layer
        if (!map_object.getLayer(layer_id_fill)) {
          map_object.addLayer({
            id: layer_id_fill,
            source: layer_id_fill,
            type: "fill",
            paint: {
              "fill-color": colors_layer_flood,
              "fill-opacity": Number(sini_polygon_fill_opacity),
            },
            layout: {
              visibility: visibility,
            },
          });
        } else {
          map_object.setLayoutProperty(layer_id_fill, "visibility", visibility);
          map_object.setPaintProperty(
            layer_id_fill,
            "fill-opacity",
            Number(sini_polygon_fill_opacity)
          );
        }

        // Add or update line layer
        if (!map_object.getLayer(layer_id_line)) {
          map_object.addLayer({
            id: layer_id_line,
            source: layer_id_fill,
            type: "line",
            paint: {
              "line-color": colors_layer_flood,
              "line-width": Number(sini_polygon_line_width),
              "line-opacity": 1,
              "line-gap-width": 0,
            },
            layout: {
              visibility: visibility,
            },
          });
        } else {
          map_object.setLayoutProperty(layer_id_line, "visibility", visibility);
          map_object.setPaintProperty(
            layer_id_line,
            "line-width",
            Number(sini_polygon_line_width)
          );
        }
      });
    }
  };

  render() {
    return <M_S_FLOOD_NEIGHBOR />;
  }
}

const mapStateToProps = (state) => ({
  sini: state.sini,
  layer: state.layer,
  properties: state.properties,
});

export default connect(mapStateToProps, {})(LAYER_S_FLOOD_NEIGHBOR);
